module.exports = __webpack_public_path__ + "media/images/emblems/Steinar-18d2e5403f7c805734ee23d66badf591.png";